import { apiLegacy } from "@/services/api-legacy";
import { AxiosError } from "axios";
import { createToast } from "vercel-toast";
import {
  DeleteBookingApiParams,
  DeleteBookingItemApiResponse,
} from "./delete-booking-item.types";

export const DeleteBookingApi = async (params: DeleteBookingApiParams) => {
  try {
    const cancellDate = new Date(params.cancel_date);

    const date = `${String(cancellDate.getUTCDate()).padStart(2, "0")}/${String(cancellDate.getUTCMonth() + 1).padStart(2, "0")}/${cancellDate.getUTCFullYear()}`;

    const { data } = await apiLegacy.delete<DeleteBookingItemApiResponse>(
      `/v0/privaterooms/bookings/${params.id}`,
      {
        data: {
          cancel_date: date,
        },
      },
    );

    createToast(data.message, {
      type: "success",
      timeout: 2000,
    });

    return {
      data: data,
    };
  } catch (err) {
    const error = err as AxiosError;
    const data = error.response?.data as DeleteBookingItemApiResponse;

    createToast(data.message, {
      type: "error",
      timeout: 2000,
    });

    return {
      data: err,
    };
  }
};
